/**
 * Read More Component
 *
 * Toggles visibility of long content sections, showing a fade-collapsed
 * preview by default with an accessible expand/collapse button.
 *
 * Usage in HTML:
 *   <div data-x-data="readMore"> ... </div>
 *
 * Exposed state:
 *   - expanded (boolean): Whether the full content is visible
 */
export default function readMore() {
    return {
        expanded: false,
        overflows: true,

        init() {
            if (this.$el.closest('.insight-type-real-tea')) {
                this.overflows = false;
                return;
            }

            this.$nextTick(() => {
                const body = this.$el.querySelector('#read-more-body');
                if (body) {
                    this.overflows = body.scrollHeight > body.clientHeight;
                }
            });
        },

        toggle() {
            this.expanded = !this.expanded;
        },
    };
}
